import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { TimeEnum } from "../../../../lib/enums";
import { FILTER_KEYWORDS } from "../../../search/consts";
import { getSearchPivotLink } from "../../util";
import SampleReportGridUriStats from "../details/SampleReportGrid/SampleReportGridUriStats";
import SampleReportGridClassification from "../details/SampleReportGrid/SampleReportGridClassification";
import { Grid } from "../../../../components/Grid";

const SourcesNetworkReferences = ({ urls }) => {
  const gridSchema = {
    fields: [
      {
        name: "network_references_url",
        displayTitle: "URL",
        className: "overflow-ellipsis",
        component: data => (
          <Link
            to={getSearchPivotLink(
              `uri:"${data.value}"`,
              {
                time_type: FILTER_KEYWORDS.FIRST_SEEN,
                period_type: TimeEnum.LAST_MONTH
              },
              false,
              "cloud"
            )}
            className="sample-report-grid__link"
          >
            {data.value}
          </Link>
        )
      },
      {
        name: "network_references_classification",
        displayTitle: "Classification",
        className: "overflow-ellipsis",
        component: data => <SampleReportGridClassification url={data.value} />,
        style: {
          width: "230px"
        }
      },
      {
        name: "network_references_threat_counts",
        displayTitle: "Threat counts",
        className: "overflow-ellipsis",
        component: data => <SampleReportGridUriStats url={data.value} />,
        style: {
          width: "230px",
          textAlign: "center"
        }
      }
    ]
  };

  return (
    <>
      {urls.length ? (
        <Grid schema={gridSchema} data={urls} />
      ) : (
        <p>
          <b>No Network Locations for This Sample</b>
        </p>
      )}
    </>
  );
};

SourcesNetworkReferences.propTypes = {
  urls: PropTypes.arrayOf(PropTypes.object)
};

export default SourcesNetworkReferences;
